import {
    formatDateNoTime,
    formatYDM,
    getToken,
    getToken2,
    getUser,
    getTime12,
} from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";
import Moment from "moment";
import formData from "react-form-data";

export const getHoliday = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "holidays/get_holiday",
            {
                requester: getUser(),
                token: getToken(),
                holiday_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAllHoliday = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "holidays/search",
            {
                requester: getUser(),
                token: getToken(),
                name: data.name,
                type: data.type,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
                page: data.page
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const createHoliday = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "holidays/create",
            {
                requester: getUser(),
                token: getToken(),
                name: info.name,
                date: Moment(info.date).format("YYYY-MM-DD"),
                rate: info.rate,
                type: info.type,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateHoliday = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "holidays/update",
            {
                requester: getUser(),
                token: getToken(),
                holiday_id: info.id,
                name: info.name,
                date: Moment(info.date).format("YYYY-MM-DD"),
                rate: info.rate,
                type: info.type,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteHoliday = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "holidays/delete",
            {
                requester: getUser(),
                token: getToken(),
                holiday_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};